import {CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA} from "@angular/core";
import {ImportIataComponent} from "./import-iata.component";
import {ImportIataRoutingModule} from "./import-iata-routing.module";

@NgModule({
  imports: [
    ImportIataRoutingModule
  ],
  declarations: [
    ImportIataComponent
  ],
  providers: [
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ]
})
export class ImportIataModule { }



// WEBPACK FOOTER //
// ./src/app/import-iata/import-iata.module.ts